<template>
  <div class="app-container">
    <el-row
      style="margin-top: 20px; margin-bottom: 10px"
      :gutter="10"
      class="mb8"
    >
      <el-col :span="3">
        <el-input
          clearable
          size="mini"
          v-model="param.keywords"
          placeholder="请输入关键字"
        ></el-input>
      </el-col>
      <el-col :span="1.5">
        <el-button
          type="warning"
          icon="el-icon-search"
          size="mini"
          @click="GetSearchAps"
          >搜索</el-button
        >
      </el-col>
      <el-col :span="1.5">
        <el-button
          type="primary"
          icon="el-icon-plus"
          size="mini"
          @click="handleAdd"
          >新增</el-button
        >
      </el-col>
      <el-col :span="1.5">
        <el-button
          type="success"
          icon="el-icon-edit"
          size="mini"
          :disabled="single"
          @click="handleUpdate"
          >修改</el-button
        >
      </el-col>
      <el-col :span="1.5">
        <el-button
          type="danger"
          icon="el-icon-delete"
          size="mini"
          :disabled="multiple"
          @click="handleDelete"
          >删除</el-button
        >
      </el-col>
    </el-row>

    <el-table
      :data="DataList"
      @selection-change="handleSelectionChange"
      style="width: 100%">
      <el-table-column type="selection" width="30" />
      <el-table-column
        prop="task_name"
        label="定时任务标题"
        >
      </el-table-column>
      <el-table-column
        prop="func"
        label="定时任务函数"
        >
        <template slot-scope="scope">
          {{translateFunc(scope.row.func)}}
        </template>
      </el-table-column>
      <el-table-column
        prop="args[0]"
        label="Shell脚本语言">
      </el-table-column>
      <el-table-column
        prop="trigger"
        label="任务类型">
        <template slot-scope="scope">
          {{translateTrigger(scope.row.trigger)}}
        </template>
      </el-table-column>
      <el-table-column
        prop="hour"
        label="定时时间(时)">
      </el-table-column>
      <el-table-column
        prop="minute"
        label="定时时间(分)">
      </el-table-column>
      <el-table-column
        prop="seconds"
        label="定时时间(秒)">
      </el-table-column>
      <el-table-column
        prop="create_time"
        label="创建时间">
      </el-table-column>
      <el-table-column
        prop="create_time"
        label="状态">
        <template slot-scope="scope">
            <el-switch
                @change="ChangeIsStart(scope.row)"
                v-model="scope.row.is_start"
                :active-value='1'
                :inactive-value='0'
                active-color="#13ce66"
                inactive-color="#ff4949">
            </el-switch>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="120"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <i
            class="el-icon-edit"
            style="color: rgb(24, 144, 255); cursor: pointer"
            @click="handleUpdate(scope.row)"
            >修改</i
          >
          <i
            style="margin-left: 10px; color: rgb(24, 144, 255); cursor: pointer"
            class="el-icon-delete"
            @click="handleDelete(scope.row)"
            >删除</i
          >
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="60%">
      <el-form
        :model="form"
        :rules="rules"
        ref="ruleForm"
        label-width="130px"
        class="demo-ruleForm"
      >
        <el-form-item label="定时任务标题" prop="task_name">
          <el-input
            v-model="form.task_name"
            placeholder="请输入定时任务标题"
          ></el-input>
        </el-form-item>
        <el-form-item label="定时任务函数" prop="func">
          <el-select
            style="width: 100%"
            v-model="form.func"
            placeholder="请选择定时任务函数"
          >
            <el-option
              v-for="item in SelectData.func_type"
              :key="item.key"
              :label="item.val"
              :value="item.key"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Shell脚本语言" prop="args">
          <el-input
            v-model="form.args[0]"
            placeholder="请输入Shell脚本语言"
          ></el-input>
        </el-form-item>
        <el-form-item label="任务类型" prop="trigger">
          <el-select
            style="width: 100%"
            v-model="form.trigger"
            placeholder="请选择任务类型"
            @change="ChangeTrigger"
          >
            <el-option
              v-for="item in SelectData.aps_type"
              :key="item.key"
              :label="item.val"
              :value="item.key"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="form.trigger == 'cron'"
          label="定时时间(时)"
          prop="hour"
        >
          <el-select
            style="width: 100%"
            v-model="form.hour"
            placeholder="请选择定时时间(时)"
          >
            <el-option
              v-for="item in Time"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="form.trigger == 'cron'"
          label="定时时间(分)"
          prop="minute"
        >
          <el-select
            style="width: 100%"
            v-model="form.minute"
            placeholder="请选定时时间(分)"
          >
            <el-option
              v-for="item in Minutes"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item  v-if="form.trigger == 'cron'" label="定时时间(秒)" prop="seconds">
          <el-select
            style="width: 100%"
            v-model="form.seconds"
            placeholder="请选择定时时间(秒)"
          >
            <el-option
              v-for="item in Minutes"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item  v-if="form.trigger != 'cron'" label="定时时间(秒)" prop="seconds">
          <el-input
            v-model="form.seconds"
            type="number"
            min="0"
            placeholder="请输入定时时间(秒)"
          ></el-input>
        </el-form-item>
        <el-form-item style="text-align: left;" label="是否启用定时任务" prop="seconds">
            <el-switch
                v-model="form.is_start"
                :active-value='1'
                :inactive-value='0'
                active-color="#13ce66"
                inactive-color="#ff4949">
            </el-switch>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  test_aps,
  add_aps,
  remove_aps,
  search_aps,
  update_aps,
  aps_select,
} from "../../api/TimedTask.js";
export default {
  data() {
    return {
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      DataList: [],
      param: {
        keywords: "",
        pageNum: 1,
        pageSize: 10,
      },
      SelectData: {},
      dialogTitle: "新增定时定时任务",
      dialogVisible: false,
      form: {
        task_name: "",
        func: "",
        args: [""],
        trigger: "",
        day: "*",
        hour: "",
        minute: "",
        seconds: "",
        is_start:0
      },
      rules: {},
      Time: [],
      Minutes: [],
    };
  },
  created() {
    this.GetSearchAps();
    this.GetApsSelect();
    this.initializationArr();
  },
  methods: {
    // 翻译定时任务函数
    translateFunc(key){
      let Name=''
      this.SelectData.func_type.forEach(item=>{
        if(item.key == key){
          Name = item.val
        }
      })
      return Name
    },
    // 翻译定时任务类型
    translateTrigger(key){
      let Name=''
      this.SelectData.aps_type.forEach(item=>{
        if(item.key == key){
          Name = item.val
        }
      })
      return Name
    },
      // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map((item) => item.id);
      this.single = selection.length != 1;
      this.multiple = !selection.length;
    },
    //   初始化时分秒数组数据
    initializationArr() {
      this.Time = [];
      this.Minutes = [];
      for (let i = 0; i <= 24; i++) {
        this.Time.push(i);
      }
      for (let i = 0; i <= 60; i++) {
        this.Minutes.push(i);
      }
    },
    // 获取定时任务数据列表
    GetSearchAps() {
      search_aps(this.param).then((res) => {
        if (res.code == 200) {
          this.DataList = res.data.list;
        }
      });
    },
    // 获取定时任务函数以及任务类型选择数组
    GetApsSelect() {
      aps_select().then((res) => {
        this.SelectData = res;
      });
    },
    // 切换定时任务启动状态
    ChangeIsStart(item){
      console.log(item,88)
      let Tips = ''
      if(item.is_start == 0){
        Tips = '此操作将启动定时任务, 是否继续?'
      }else{
        Tips = '此操作将关闭定时任务, 是否继续?'
      }
      this.$confirm(`${Tips}`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let CopyForm = JSON.parse(JSON.stringify(item))
        if(item.is_start == 0){
          CopyForm.is_start == 1
        }else{
          CopyForm.is_start == 0
        }
        update_aps(CopyForm).then((res) => {
          if (res.code == 200) {
            this.GetSearchAps();
            this.$message({
              type: 'success',
              message: '操作成功!'
            });
          }
        });
      }).catch(() => {
        this.GetSearchAps();
        this.$message({
          type: 'info',
          message: '已取消操作'
        });          
      });
    },
    // 切换任务类型事件
    ChangeTrigger(e) {
      if (e == "cron") {
        this.form.hour = "";
        this.form.minute = "";
        this.form.day = "*";
      }
    },
    handleAdd() {
      this.form = {
        task_name: "",
        func: "",
        args: [""],
        trigger: "",
        seconds: null,
        hour : "",
        minute : "",
        day : "*",
        is_start:0
      };
      this.dialogTitle = "新增定时任务";
      this.dialogVisible = true;
    },
    handleUpdate(item) {
      this.dialogTitle = "修改定时任务";
      this.dialogVisible = true;
      this.form = JSON.parse(JSON.stringify(item));
    },
    handleDelete(item) {
      var id;
      if (item.id) {
        id = [item.id];
      } else {
        id = this.ids;
      }
      this.$confirm("此操作将永久删除该定时任务, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          remove_aps({ task_names: id }).then((res) => {
            if (res.code == 200) {
              this.GetSearchAps();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    cancel() {
      this.dialogTitle = "新增定时任务";
      this.dialogVisible = false;
      this.form = {
        task_name: "",
        func: "",
        args: [""],
        trigger: "",
        day: "*",
        hour: "",
        minute: "",
        seconds: "",
        is_start:0
      };
      this.GetSearchAps();
    },
    confirm() {
      if (this.dialogTitle == '修改定时任务') {
        let CopyForm = JSON.parse(JSON.stringify(this.form));
        update_aps(CopyForm).then((res) => {
          if (res.code == 200) {
            this.cancel();
          }
        });
      } else {
        let CopyForm = JSON.parse(JSON.stringify(this.form));
        CopyForm.args.push(this.form.task_name);
        add_aps(CopyForm).then((res) => {
          if (res.code == 200) {
            this.cancel();
          }
        });
      }
    },
  },
};
</script>

<style>
</style>